import { useState, useCallback, createContext } from 'react';
import { IFinanceQuote } from '../model/IFinanceQuote';

export interface IFinanceQuoteContext {
  financeQuote: IFinanceQuote | null;
  setFinanceQuote: (quote: IFinanceQuote) => void;
  secondaryFinanceQuote: IFinanceQuote | null;
  setSecondaryFinanceQuote: (quote: IFinanceQuote) => void;
  resetFinanceQuote: () => void;
}

export const FinanceQuoteContext = createContext<IFinanceQuoteContext>({
  financeQuote: null,
  secondaryFinanceQuote: null,
  setFinanceQuote: () => null,
  setSecondaryFinanceQuote: () => null,
  resetFinanceQuote: () => null,
});

export const getFinanceQuoteContextValue: () => IFinanceQuoteContext = () => {
  const initialFinanceQuote: IFinanceQuote = {
    token: '',
    isCashProduct: null,
    comparisonRate: 10.87,
    monthlyPayment: 132.3,
    duration: 12,
    interestRate: 12.1,
    totalAmountFinanced: 0,
    packageCode: 'AU_SUB_NHO-W',
    financeProductKey: '',
  };

  const [financeQuote, setFQ] = useState(initialFinanceQuote);

  // TODO: Should be remove after secondary finance quote is available on /configure-deal endpoint
  const [secondaryFinanceQuote, setSecondaryFQ] = useState({
    token: '',
    isCashProduct: null,
    comparisonRate: 10.87,
    monthlyPayment: 1000.3,
    duration: 12,
    interestRate: 12.1,
    totalAmountFinanced: 0,
    packageCode: 'AU_SUB_NHO-W',
    financeProductKey: '',
  });

  const setFinanceQuote = useCallback((quote: IFinanceQuote) => {
    setFQ(quote);
  }, []);

  const setSecondaryFinanceQuote = useCallback((quote: IFinanceQuote) => {
    setSecondaryFQ(quote);
  }, []);

  const resetFinanceQuote = useCallback(() => setFQ(initialFinanceQuote), []);

  return { financeQuote, setFinanceQuote, secondaryFinanceQuote, setSecondaryFinanceQuote, resetFinanceQuote };
};
